import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Icon from "components/templatesComponents/Icon";
import { useFindPages } from "hooks/page.hook";
import PropTypes from "prop-types";
import React from "react";
import { digitFormatDate } from "utils/commonUtils";

const PageDate = (props) => {
  const { page: pageVersion, position = "center", iconColor = "inherit", sx, ...others } = props;

  const { publishedDate, updated, pageId, page } = pageVersion || {};
  const { lang, originalPageId, siteId } = page;

  const { data: frenchPnuPages = [] } = useFindPages({
    siteId,
    pageId: lang === "FR" ? pageId : originalPageId,
    filters: [`page.lang||eq||FR`],
  });

  const { publishedDate: frenchPublishedDate, updated: frenchPageUpdated } = frenchPnuPages[0] || {};

  const pageDate = publishedDate || updated;
  const frenchPageDate = frenchPublishedDate || frenchPageUpdated;
  const date = lang === "FR" ? pageDate : frenchPageDate || pageDate;

  let justify = position;
  if (position === "left") {
    justify = "flex-start";
  } else if (position === "right") {
    justify = "flex-end";
  }

  return (
    <Grid container {...others} sx={{ justifyContent: justify, alignItems: "center", ...sx }}>
      <Icon iconDSFR="time-line" sx={{ color: iconColor, fontSize: "1rem" }} title="Date" />
      <Box sx={{ ml: 1 }}>
        <p className="fr-text--xs">{digitFormatDate({ date, lang })}</p>
      </Box>
    </Grid>
  );
};

PageDate.propTypes = {
  page: PropTypes.shape().isRequired,
  position: PropTypes.oneOf(["left", "center", "right"]),
  iconColor: PropTypes.string,
  sx: PropTypes.object,
};
export default PageDate;
